module.exports = __webpack_public_path__ + "static/img/use-template.7f9e106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/use-template.jpg
// module id = PzPN
// module chunks = 1